import { Revision } from 'types'
import { EditorView } from 'prosemirror-view'
import { Copy } from 'almanac-ui/icons'
import { markdownParser } from 'prose-core'
import { clearRevisionMarks } from 'components/AIRevision/clearRevisionMarks'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface Props {
  revision: Revision
  view: EditorView
}

export const CopyIconButton = ({ revision, view }: Props) => {
  const handlePress = () => {
    const node = markdownParser.parse(revision.content)
    navigator.clipboard.writeText(node?.textContent || '')
    const tr = clearRevisionMarks(view.state.tr)
    view.dispatch(tr)
    showToastMessage('Generated text copied', 'success')
  }

  return (
    <IconButton
      aria-label="Copy"
      icon={Copy}
      size="sm"
      variant="secondary"
      onPress={handlePress}
      isDisabled={revision.content.trim().length < 1}
    />
  )
}
